export function cityDisplayNameToShiftPrefix(cityName: string | null | undefined): string {
  if (!cityName) return '';

  const trimmedName = cityName.trim();
  if (trimmedName.length === 0) return '';

  return trimmedName
    .toUpperCase()
    // replace all non-alphanumeric characters with an underscore
    .replace(/[^A-Z0-9]+/g, '_')
    // strip leading/trailing underscores
    .replace(/^_+|_+$/g, '');
}
